exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".teacherPreviewNotice{padding:10px;margin-bottom:5px;text-align:center;border-radius:6px;margin-left:auto;margin-right:auto;max-width:750px}.teacherPreviewNotice .btn{margin-left:10px;padding:3px 10px;font-size:.8em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/utility/teacher_preview_notice.scss
// module id = 1457
// module chunks = 0